import createReducer from 'utils/createReducer';

const CHANGE_ALERT_REQUEST = 'alerts/CHANGE_ALERT_REQUEST';
const SET_FETCHING = 'alerts/SET_FETCHING';
const SET_DATA = 'alerts/SET_DATA';
const SET_DATA_CHANGE = 'alerts/SET_DATA_CHANGE';

// Initial State
const INIT_STATE = {
  shipper_order: {},
  changing: false,
  fetching: {},
};

// Reducers
export default createReducer(INIT_STATE, {
  [CHANGE_ALERT_REQUEST](state, { changing }) {
    return {
      ...state,
      changing,
    };
  },
  [SET_FETCHING](state, { id, fetching }) {
    return {
      ...state,
      fetching: {
        ...state.fetching,
        [id]: fetching,
      },
    };
  },
  [SET_DATA](state, { id, data }) {
    return {
      ...state,
      shipper_order: {
        [id]: data,
      },
    };
  },
  [SET_DATA_CHANGE](state, { shipperOrderId, alert }) {
    return {
      ...state,
      shipper_order: {
        [shipperOrderId]: state.shipper_order[shipperOrderId].map((a) => {
          if (a.id === alert.id) {
            return alert;
          }
          return a;
        }),
      },
    };
  },
});

export const setFetching = ({ id, fetching }) => {
  return {
    type: SET_FETCHING,
    payload: {
      id,
      fetching,
    },
  };
};

export const setData = ({ id, data }) => {
  return {
    type: SET_DATA,
    payload: {
      id,
      data,
    },
  };
};

export const setChanging = ({ changing }) => {
  return {
    type: CHANGE_ALERT_REQUEST,
    payload: {
      changing,
    },
  };
};

export const setDataChange = ({ shipperOrderId, alert }) => {
  return {
    type: SET_DATA_CHANGE,
    payload: {
      shipperOrderId,
      alert,
    },
  };
};
